import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApnPdeApi } from "apis/ApnPdeApi";
import { ApnPdeSearchFilterQuery } from "models/filters/apnPde/ApnPdeSearchFilterQuery";

export const CheckDuplicateApnPde = createAsyncThunk("apnPdeSlice/ApnPdeSearchFilterQuery", async (params: ApnPdeSearchFilterQuery) => {
    const response = await ApnPdeApi.Search(params);
    return response.data;
});
